import { Loc, t } from "@/locales";

type Props = {
  onDownloadPDF: () => void;
};

export function ConfiguratorActions(props: Props) {
  return (
    <div className="configurator-actions">
      <button
        type="button"
        onClick={props.onDownloadPDF}
        className="configurator-actions__button"
      >
        {t(Loc.downloadOffer)}
      </button>
    </div>
  );
}
